import { apiSimulacao } from "~services/utils/api";

export const salvarSimulacao = async (simulacao) => {
    const res = await apiSimulacao.post(`/api/Simulacao`, simulacao).then((response) => {
      if (response.data === undefined) return response;
      return response.data;
    });
    return res;
  };

export const enviarAprovacao = async (simulacaoAprovacao) => {
    const res = await apiSimulacao.post(`/api/PortalAprovacao`, simulacaoAprovacao).then((response) => {
      if (response.data === undefined) return response;
      return response.data;
    });
    return res;
  };


export const consultarBeneficioFiscal = async (simulacaoId) => {
  const res = await apiSimulacao.get(`/api/PortalAprovacao/BeneficioFiscal/${simulacaoId}`).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};